export default "__VITE_PUBLIC_ASSET__db68f3c8__"